import { BcfServicesIntegrationType } from "@faro-lotv/service-wires";
import { useEffect, useRef, type JSX } from "react";
import {
  AnnotationEditorHeader,
  AnnotationEditorHeaderProps,
} from "./annotation-editor/annotation-editor-header";

type ExternalAnnotationEditorHeaderProps = AnnotationEditorHeaderProps & {
  annotationType: BcfServicesIntegrationType;
};

/**
 * @returns the UI control for getting the title of an external annotation
 */
export function ExternalAnnotationEditorHeader({
  annotationType,
  title,
  autoFocusTitle,
  onTitleChange,
  errorMessage,
  onSetErrorMessage,
  disabled,
}: ExternalAnnotationEditorHeaderProps): JSX.Element {
  const titleInputRef = useRef<HTMLInputElement>(null);
  useEffect(() => {
    // Focus on the title input field when the form is first shown or when externalAnnotation Type changes
    // Because of timing issues, we need to use setTimeout to make sure that the input is rendered before we try to focus it
    setTimeout(() => {
      if (titleInputRef.current) {
        titleInputRef.current.focus();
        titleInputRef.current.select();
      }
    });
  }, [annotationType, autoFocusTitle]);

  return (
    <AnnotationEditorHeader
      title={title}
      errorMessage={errorMessage}
      onSetErrorMessage={onSetErrorMessage}
      onTitleChange={onTitleChange}
      disabled={disabled}
      inputRef={titleInputRef}
    />
  );
}
